module.exports = __webpack_public_path__ + "static/media/user.2d9d5766.png";